export default function assetUrl(path: string) {
  return `${path}?v=${process.env.BUILD_TIME}`;
}